function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "VOD-to-Live-ready-to-go",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Media/file/upload.selected",
  transform: "translate(-1144.000000, -336.000000)",
  fill: "#707070"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy-3",
  transform: "translate(260.000000, 312.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Symbol/cross",
  transform: "translate(882.214887, 22.214887)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.785113,3.45177969 C12.2453503,3.45177969 12.6184464,3.82487573 12.6184464,4.28511302 L12.6177797,10.9507797 L19.285113,10.9517797 C19.7453503,10.9517797 20.1184464,11.3248757 20.1184464,11.785113 C20.1184464,12.2453503 19.7453503,12.6184464 19.285113,12.6184464 L12.6177797,12.6177797 L12.6184464,19.285113 C12.6184464,19.7453503 12.2453503,20.1184464 11.785113,20.1184464 C11.3248757,20.1184464 10.9517797,19.7453503 10.9517797,19.285113 L10.9517797,12.6177797 L4.28511302,12.6184464 C3.82487573,12.6184464 3.45177969,12.2453503 3.45177969,11.785113 C3.45177969,11.3248757 3.82487573,10.9517797 4.28511302,10.9517797 L10.9517797,10.9507797 L10.9517797,4.28511302 C10.9517797,3.82487573 11.3248757,3.45177969 11.785113,3.45177969 Z",
  id: "Combined-Shape",
  transform: "translate(11.785113, 11.785113) rotate(-45.000000) translate(-11.785113, -11.785113) "
})))));

function SvgIcnCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "431A31AC-FF52-4ECD-B236-753DB6287930") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCross);
export default __webpack_public_path__ + "static/media/icn-cross.0c0e0e7f.svg";
export { ForwardRef as ReactComponent };